import { useStyletron } from "baseui";
import Heatmap from "./Heatmap";
import { TimeRange, startEndDateFromTimeRange } from "../../../../utils/timeUtils";
import { FormattedMessage } from "react-intl";
import { HeadingSmall, HeadingXSmall, ParagraphMedium, ParagraphSmall } from "baseui/typography";
import { OperatorPanelWrapperFullSize } from "../../../components/Layout";
import { useGetBuildings } from "../../../../hooks/useGetBuildings";
import { default as HeatmapBuilding } from '../../Energy/HeatmapBuilding/Heatmap'
import { HierarchyObjectNavigation } from "../../../../components/HierarchyNavigation";
import { ListItem, ListItemLabel } from "baseui/list";
import { VerticalStackPanel } from "../../../../components/Layout/StackPanel";

export const OperatorPanel = (props: any) => {
    const [css, theme] = useStyletron();
    const range = props.timeRange ?? TimeRange.Last12Months;
    const { start, end } = startEndDateFromTimeRange(range);

    const { items } = useGetBuildings();

    return (
        <OperatorPanelWrapperFullSize
            {...props}
            statusContent={<>
                <ParagraphMedium><FormattedMessage id={TimeRange[range]} defaultMessage={TimeRange[range]} /> | MWh</ParagraphMedium>
                <Heatmap valueFactor={0.001} dimension={'MWh'}  start={start} end={end}></Heatmap>
            </>} >

            <HeadingXSmall className={css({ alignSelf: 'flex-start' })} margin={0}><FormattedMessage id={"PortfolioEnergyHeatmap.buildings"} defaultMessage={'Buildings'} /></HeadingXSmall>
            <ul className={css({
                alignSelf: 'flex-start',
                paddingLeft: 0,
                paddingRight: 0,
                width: '100%',
                marginTop: 0
            })}>
                {items?.map((v) =>

                    <ListItem key={v.id}>
                        <VerticalStackPanel>
                            <ParagraphSmall marginBottom={0}>
                                <HierarchyObjectNavigation objectId={v.id} resourceGroupId={v.resourceGroupId} currentAsLink current={v.name} currentDescription={v.description} showDescription  ></HierarchyObjectNavigation>
                            </ParagraphSmall>
                            <HeatmapBuilding showLegend={false} {...v} timeRange={range} ></HeatmapBuilding>
                        </VerticalStackPanel>
                    </ListItem>
                )}

            </ul>
        </OperatorPanelWrapperFullSize>
    )
}